export default {
      id: "list-usage",
      viewBox: "0 0 11 14",
      url: __webpack_public_path__ + "img/icons.svg#list",
      toString: function () {
        return this.url;
      }
    }